import { Navigate } from 'react-router';
import { useSmartDefaultRoute } from '@/hooks/useSmartDefaultRoute';

export function SmartDefaultRoute() {
  const { targetPath, isLoading } = useSmartDefaultRoute();

  if (isLoading) {
    return null;
  }

  return <Navigate to={targetPath} replace />;
}
